class UserService {

    async sendResetPasswordEmail(email, returnUrl) {
        let response = await fetch('/Users/SendResetPasswordEmail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                email,
                returnUrl
            })
        });

        return response;
    }

    async resetPassword(email, code, codeType, newPassword, confirmNewPassword, returnUrl) {
        try {
            let response = await fetch('/Users/ResetPassword',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        email: email,
                        code: code,
                        codeType: codeType,
                        newPassword: newPassword,
                        confirmNewPassword: confirmNewPassword,
                        returnUrl
                    })
                });

            if (response.ok === false) {
                throw (response.json());
            }

            return response.json();
        } catch (e) {
            throw (e);
        }
    }

    async confirmRegistration(userId, code, returnUrl) {
        try {
            let response = await fetch('/Users/ConfirmRegistration',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        userId: userId,
                        code: code,
                        returnUrl: returnUrl
                    })
                });

            if (response.Ok === false) {
                throw (response.json());
            }

            return response.json();
        } catch (e) {
            throw (e);
        }
    }

    async confirmEmail(userId, code, returnUrl) {
        try {
            let response = await fetch('/Users/ConfirmRegistration',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        userId: userId,
                        code: code,
                        returnUrl: returnUrl
                    })
                });

            if (response.Ok === false) {
                throw (response.json());
            }

            return response.json();
        } catch (e) {
            throw (e);
        }
    }

    async confirmProviderEmail(userId, code, returnUrl, provider, id) {
        let response = await fetch('/Users/ConfirmProviderEmail',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify({
                    userId,
                    code,
                    returnUrl,
                    provider,
                    id
                })
            });

        if (response.ok === false) {
            throw (response.json());
        }

        return response.json();
    }
};


const userService = new UserService();

export default userService;